import { useQuery } from '@tanstack/react-query';
import restClient from '../common/api/restClient';

export const useProfileScorecardById = (id = null) => {
  const prefix = process.env.REACT_APP_PUBLIC_PREFIX || '';
  return useQuery({
    queryKey: ['useProfileScorecardById', id],
    queryFn: async () => {
      const url = id ? `${prefix}/public/profile-scorecards/${id}` : '';
      const result = await restClient({ url });
      return result;
    },
    staleTime: 0,
    cacheTime: 0,
  });
};